import { render } from "./TodayDeliveryStartDialog.vue?vue&type=template&id=16890fee&scoped=true&ts=true"
import script from "./TodayDeliveryStartDialog.vue?vue&type=script&lang=ts"
export * from "./TodayDeliveryStartDialog.vue?vue&type=script&lang=ts"

import "./TodayDeliveryStartDialog.vue?vue&type=style&index=0&id=16890fee&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2051669892/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16890fee"]])

export default __exports__